import { render, staticRenderFns } from "./svg-component.vue?vue&type=template&id=3c2b853e&"
import script from "./svg-component.vue?vue&type=script&lang=js&"
export * from "./svg-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2b853e')) {
      api.createRecord('3c2b853e', component.options)
    } else {
      api.reload('3c2b853e', component.options)
    }
    module.hot.accept("./svg-component.vue?vue&type=template&id=3c2b853e&", function () {
      api.rerender('3c2b853e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/ui/svg-component.vue"
export default component.exports